var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-button rating-raise"},[_c('svg',{staticClass:"rating__icon"},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.icon}})]),_c('div',{staticClass:"rating-button__title"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }